import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import QueueOverrideListModal from "../QueueOverrideListModal";

const useStyles = makeStyles(theme => ({
  queueOverrideRequestsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "99.50vw",
    height: "25px",
    borderRadius: "5px",
    backgroundColor: theme.palette.primary.main,
    cursor: "pointer",
    overflow: "hidden",
    "&:hover": { opacity: "0.95" },
  },

  queueOverrideRequestsSpan: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    msTextOverflow: "ellipsis",
    width: "100%",
    textAlign: "center",
  }
}));

const QueueOverrideRequestsSpan = ({ user }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  
  const [queueOverrideListModalOpen, setQueueOverrideListModalOpen] = useState(false);



  //  ***************
  //  ** Functions **
  //  ***************
  const handleOpenQueueOverrideListModal = () => {
    setQueueOverrideListModalOpen(true);
  };

  const handleFalseQueueOverrideListModal = () => {
    setQueueOverrideListModalOpen(false);
  };



  //  ************
  //  ** Return **
  //  ************
  return (
    <>
      <QueueOverrideListModal
        open={queueOverrideListModalOpen}
        onClose={handleFalseQueueOverrideListModal}
      />

      <div className={classes.queueOverrideRequestsContainer} onClick={handleOpenQueueOverrideListModal}>
        <span className={classes.queueOverrideRequestsSpan}>
          {user.canAuthorizeQueueOverride
            ? i18n.t("queueOverrideRequestsSpan.resolverUserMessage")
            : i18n.t("queueOverrideRequestsSpan.requestUserMessage")
          }
        </span>
      </div>
    </>
  );
};

export default QueueOverrideRequestsSpan;
